'use strict';

angular.module('msCore').filter('headerHtml', ['$sce', function ($sce) {
  return function (header) {
    if (header && header.htmlTemplate && header.content) {
      var html = header.htmlTemplate;
      header.content.forEach(function (replacement) {
        // replace all replacement.target with replacement.replacement
        html = html.split('{{' + replacement.target + '}}').join(replacement.replacement);
      });
      html = html.replace(/{{.*}}/, '');
      return $sce.trustAsHtml(html);
    }
  };
}]);